<template>
  <div class="tabs">
    <slot></slot>
  </div>
</template>

<script setup>
import uniqueId from 'lodash/uniqueId'
import { ref, provide, watch } from 'vue'
import { tabKey } from './key'

const props = defineProps({
  modelValue: { type: Number, default: undefined },
  defaultIndex: { type: Number, default: 0 },
  manualActivation: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue', 'change'])

const focusedIndex = ref(props.modelValue ?? props.defaultIndex)
const activeIndex = ref(props.modelValue ?? props.defaultIndex)

const tabsId = uniqueId('tabs-')
const tabs = ref([])
const panels = ref([])

watch(
  () => props.modelValue,
  (value) => {
    if (value !== undefined) {
      // clamp the value to the number of tabs
      const validIndex = Math.max(0, Math.min(value, tabs.value.length - 1))
      focusedIndex.value = validIndex
      activeIndex.value = validIndex
    }
  },
)

const focusTab = (index) => {
  focusedIndex.value = index

  if (!props.manualActivation) {
    activateTab(index)
  }
}

const activateTab = (index) => {
  if (props.modelValue !== undefined) {
    emit('update:modelValue', index)
  } else {
    focusedIndex.value = index
    activeIndex.value = index
  }
  emit('change', index)
}

const registerTab = (id) => {
  const index = tabs.value.length
  tabs.value.push(id)
  return index
}

const registerPanel = (id) => {
  const index = panels.value.length
  panels.value.push(id)
  return index
}

provide(tabKey, {
  tabsId,
  focusedIndex,
  focusTab,
  activeIndex,
  activateTab,
  registerTab,
  registerPanel,
  tabs,
  panels,
  manualActivation: props.manualActivation,
})
</script>
